/**
 * @file config.js
 * @desc 客户公海配置文件
 * @author dingzhenyue
 */

// 转化意愿
export const wishOptions = [
  {
    label: '强',
    value: 1
  },
  {
    label: '正常',
    value: 2
  }
];

// 是否免费体验会员
export const freeVipOptions = [
  {
    label: '是',
    value: 2
  },
  {
    label: '否',
    value: 1
  }
];

// 是否自主入驻
export const clueFromOptions = [
  {
    label: '自主入驻',
    value: 2
  },
  {
    label: '代理商引入',
    value: 1
  }
];

// 客户类型
export const customerTypeList = [
  {
    label: '专属',
    value: 'firm'
  },
  {
    label: '公开',
    value: 'public'
  }
];
